import { Prop, Component, Vue } from 'vue-property-decorator';

@Component
export default class NavBarMenu extends Vue {

    @Prop({ default: false, required: false }) private readonly isHoverable!: boolean;
    @Prop({ default: true, required: false }) private readonly hasDropDownIcon!: boolean;

    private isDropdownActive = false;

    get toggleDropdownIcon(): string {
        return this.isDropdownActive ? 'chevron-up' : 'chevron-down';
    }

    private created(): void {
        window.addEventListener('click', this.forceClose);
    }

    private beforeDestroy(): void {
        window.removeEventListener('click', this.forceClose);
    }

    private forceClose(e: any): void {
        if (!this.$el.contains(e.target)) {
            this.isDropdownActive = false;
        }
    }

    private toggle(): void {
        if (!this.isHoverable) {
            this.isDropdownActive = !this.isDropdownActive;
        }
    }

}